import Vue from 'vue'
import Router from 'vue-router'

import { routes } from '@/router/routesAll.js'

import { scroller } from 'vue-scrollto/src/scrollTo'
import Auth from '@/helpers/auth/'

import { eventBus } from '@/helpers/event-bus/'

Vue.use(Router)

// https://www.programmersought.com/article/82985528840/
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err)
}

function shouldRedirectToAccount(toRoute) {
    const blockedRoutes = ['login', 'register', 'forgot-password', 'otp']
    const index = blockedRoutes.findIndex((route) => route === toRoute)
    return index !== -1 && Auth.userAuth()
}

const router = new Router({
    routes,
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (to.name === from.name) return false
        // if need scroll to id
        if (to.hash) {
            setTimeout(() => {
                const element = document.getElementById(to.hash.replace(/#/, ''))
                if (element && element.scrollIntoView) {
                    const ScrollTo = scroller();
                    ScrollTo(element, {
                        duration: 600,
                        offset: -60
                    });
                    element.scrollIntoView({ block: 'start', behavior: 'smooth' })
                }
            }, 500)
        }
        if (savedPosition) {
            return savedPosition
        }
        return { x: 0, y: 0 }
    }
});

router.beforeEach(async (to, from, next) => {
    // set true for loading property so that we can display loader animation until a route is fully loaded
    router.app.loading = true

    // redirect logged in user to account page, in case an irrelevant route is accessed
    if (shouldRedirectToAccount(to.name)) {
        next('/cp/account')
    }

    // all routes processing logic
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (!Auth.isLogged()) {
            await Auth.logout()
            await Auth.logoutVuex()
            localStorage.setItem('login_last_location', window.location.href)
            eventBus.$emit('showSnackBar', 'Session was expired', 'error')
            // window.location.href = `${window.location.origin}/login`
            router.push({ name: 'login' })
        } else {
            next()
        }
    } else {
        next();
    }
})

router.afterEach(() => {
    // remove loading animation, once our route is fully loaded
    router.app.loading = false
});

export default router
